import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { IEAreaFilter } from '../../interfaces/eregion-filter';
import { NoEmptyString } from '../../interfaces/no-empty-string.validator';
import { IPageResult } from '../../interfaces/page-result';
import { EngineiusAreaService } from '../../services';
import { OrganisationsService } from '../../services';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { IEArea } from '../../interfaces/earea';

@Component({
  selector: 'eareas',
  templateUrl: './manage-eareas.component.html',
  styleUrls: ['./manage-eareas.component.scss'],
})
export class EAreasComponent implements OnInit {
  public page: IPageResult<IEArea> = {
    items: [],
    total: 0,
  };

  public event: any;
  public filter: Subject<IEAreaFilter>;
  public filterVal: IEAreaFilter;
  public isLoaded: boolean = false;
  public displayDialog: boolean = false;
  public area: IEArea;
  public newarea: boolean = false;
  public filterString: string;
  public newEAreaForm: UntypedFormGroup;
  public name: UntypedFormControl;
  public description: UntypedFormControl;
  public isActive: UntypedFormControl;
  public selectedAreaId: number;
  public selectedItem: any;

  constructor(
    private EngineiusAreaService: EngineiusAreaService,
    private formBuilder: UntypedFormBuilder,
    private orgService: OrganisationsService,
  ) {}

  ngOnInit() {
    this.filter = new Subject<IEAreaFilter>();

    // subscribe to filter changes with a debounce time
    this.filter.pipe(debounceTime(500)).subscribe((f) => {
      this.load(f);
      this.filterVal = f;
    });

    // set default filter
    this.filter.next({ first: 0, rows: 10 });

    // set formGroup instance
    this.newEAreaForm = this.formBuilder.group({
      name: new UntypedFormControl(
        '',
        Validators.compose([Validators.required, Validators.maxLength(255), NoEmptyString]),
      ),
      id: new UntypedFormControl(''),
    });
  }

  load(filter: IEAreaFilter) {
    this.EngineiusAreaService.getPage(filter).then((result) => {
      this.page.items = result.items;
      this.page.total = result.total;
      this.isLoaded = true;
    });
  }

  showDialogToAdd() {
    this.newarea = true;
    this.area = {
      id: 0,
      name: '',
    };
    this.resetFormValues(this.area);
    this.displayDialog = true;
  }

  save() {
    let fv = this.newEAreaForm.value;

    this.EngineiusAreaService.save(fv, fv.id == 0).then((res) => this.load(this.filterVal));
    this.displayDialog = false;
  }

  close() {
    this.displayDialog = false;
  }

  resetFormValues(formValues) {
    this.newEAreaForm.patchValue({
      id: formValues.id,
      name: formValues.name,
    });
  }

  onRowSelect(event) {
    this.event = event;
  }

  onRowDblclick(item) {
    this.newarea = false;
    this.resetFormValues(this.selectedItem);
    this.displayDialog = true;
  }

  onEdit() {
    if (this.event !== undefined) {
      this.onRowDblclick(this.event);
    }
  }

  onGridLazyLoad(event: any) {
    const eventString = JSON.stringify(event);
    if (eventString === this.filterString) return;
    this.filter.next(event);
  }

  deleteArea() {
    this.EngineiusAreaService.delete(this.selectedItem.id);

    // Remove it from view
    this.page.items = this.page.items.filter((x) => x.id != this.selectedItem.id);
  }
}
